<template>
    <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.5308 13.0737H37.3086M37.3086 13.0737V26.8515M37.3086 13.0737L23.5308 26.8515L16.6419 19.9626L6.30859 30.296" stroke="#00BF8C" stroke-width="3.44444" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
